import { Injectable } from '@angular/core';

import { datadogRum } from '@datadog/browser-rum';
import { Metric, onCLS, onINP, onLCP, onTTFB } from 'web-vitals';

import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PerformanceService {
  private initialized = false;

  init(): void {
    if (this.initialized) {
      return;
    }
    this.initialized = true;

    if (!environment.production && !environment.datadog.clientToken) {
      return;
    }

    const reportMetric = (metric: Metric): void => {
      datadogRum.addAction(`web-vital:${metric.name}`, {
        value: metric.value,
        rating: metric.rating,
        delta: metric.delta,
        id: metric.id,
        navigationType: metric.navigationType
      });
    };

    onCLS(reportMetric);
    onINP(reportMetric);
    onLCP(reportMetric);
    onTTFB(reportMetric);
  }
}
